/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing alert related components.
 * @module AviAlertBellModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { ClrSpinnerModule } from '@clr/angular';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { RightRailModule } from 'ng/modules/right-rail/right-rail.module';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { TooltipModule } from 'ng/modules/tooltip/tooltip.module';
import { VIPModule } from '@vmw/ngx-vip';

import {
    AviAlertBellBodyComponent,
    AviAlertBellComponent,
    AviAlertBellFooterComponent,
} from '.';

const components = [
    AviAlertBellBodyComponent,
    AviAlertBellComponent,
    AviAlertBellFooterComponent,
];

@NgModule({
    declarations: [
        ...components,
    ],
    exports: [
        AviAlertBellComponent,
    ],
    imports: [
        AviFormsModule,
        ClrSpinnerModule,
        CommonModule,
        OverlayModule,
        SharedModule,
        RightRailModule,
        TooltipModule,
        VIPModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AviAlertBellModule {}
